module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('md-card-content', {
    key: _vm.handler,
    staticClass: "ql-cue-body",
    style: (_vm.style())
  }, [(_vm.localCue.data) ? _c('form', {
    attrs: {
      "novalidate": ""
    },
    on: {
      "submit": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.keyPress.apply(null, arguments)
      },
      "keyup": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.keyPress.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "flex-row"
  }, [_c('md-input-container', {
    staticClass: "field-label"
  }, [_c('label', {
    attrs: {
      "for": "label"
    }
  }, [_vm._v("Label")]), _vm._v(" "), _c('md-input', {
    attrs: {
      "readonly": !_vm.editable
    },
    on: {
      "blur": function($event) {
        return _vm.modifyCue('data.label', _vm.localCue.data.label)
      }
    },
    model: {
      value: (_vm.localCue.data.label),
      callback: function($$v) {
        _vm.$set(_vm.localCue.data, "label", $$v)
      },
      expression: "localCue.data.label"
    }
  })], 1), _vm._v(" "), (!_vm.locked && !_vm.editing && _vm.editable) ? _c('md-button', {
    staticClass: "md-icon-button",
    on: {
      "click": _vm.destroy
    }
  }, [_c('md-icon', [_vm._v("delete")]), _vm._v(" "), _c('md-tooltip', [_vm._v("Delete Cue")])], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "flex-row"
  }, [(_vm.isAvailable('description')) ? _c('md-input-container', {
    staticClass: "field-description"
  }, [_c('label', {
    attrs: {
      "for": "description"
    }
  }, [_vm._v("Description")]), _vm._v(" "), _c('md-input', {
    attrs: {
      "readonly": !_vm.editable
    },
    on: {
      "blur": function($event) {
        return _vm.modifyCue('data.description', _vm.localCue.data.description)
      }
    },
    model: {
      value: (_vm.localCue.data.description),
      callback: function($$v) {
        _vm.$set(_vm.localCue.data, "description", $$v)
      },
      expression: "localCue.data.description"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.isAvailable('parts')) ? _c('md-input-container', {
    staticClass: "field-parts"
  }, [_c('label', {
    attrs: {
      "for": "parts"
    }
  }, [_vm._v("Parts")]), _vm._v(" "), _c('md-select', {
    attrs: {
      "disabled": !_vm.editable
    },
    on: {
      "change": _vm.partsChanged
    },
    model: {
      value: (_vm.localCue.data.parts),
      callback: function($$v) {
        _vm.$set(_vm.localCue.data, "parts", $$v)
      },
      expression: "localCue.data.parts"
    }
  }, _vm._l((['', 2, 3, 4, 5, 6, 7, 8]), function(part, index) {
    return _c('md-option', {
      key: index,
      attrs: {
        "value": part
      }
    }, [_vm._v(_vm._s(part))])
  }), 1)], 1) : _vm._e()], 1), _vm._v(" "), (_vm.localCue.data.parts) ? _c('div', {
    staticClass: "flex-row flex-column"
  }, _vm._l((_vm.localCue.data.partsData), function(partData) {
    return _c('div', {
      staticClass: "field-parts-data flex-row flex-column"
    }, [_c('div', {
      staticClass: "flex-row"
    }, [_c('md-input-container', {
      staticClass: "field-part"
    }, [_c('label', {
      attrs: {
        "for": "part"
      }
    }, [_vm._v("P")]), _vm._v(" "), _c('md-input', {
      attrs: {
        "readonly": !_vm.editable
      },
      on: {
        "blur": function($event) {
          _vm.modifyCue(("data.partsData[" + (_vm.getPartIndex(partData)) + "].id"), _vm.localCue.data.partsData[_vm.getPartIndex(partData)].id)
        }
      },
      model: {
        value: (_vm.localCue.data.partsData[_vm.getPartIndex(partData)].id),
        callback: function($$v) {
          _vm.$set(_vm.localCue.data.partsData[_vm.getPartIndex(partData)], "id", $$v)
        },
        expression: "localCue.data.partsData[getPartIndex(partData)].id"
      }
    })], 1), _vm._v(" "), (_vm.isAvailable('label')) ? _c('md-input-container', {
      staticClass: "field-part-label"
    }, [_c('label', {
      attrs: {
        "for": "label"
      }
    }, [_vm._v("Label")]), _vm._v(" "), _c('md-input', {
      attrs: {
        "readonly": !_vm.editable
      },
      on: {
        "blur": function($event) {
          _vm.modifyCue(("data.partsData[" + (_vm.getPartIndex(partData)) + "].label"), _vm.localCue.data.partsData[_vm.getPartIndex(partData)].label)
        }
      },
      model: {
        value: (_vm.localCue.data.partsData[_vm.getPartIndex(partData)].label),
        callback: function($$v) {
          _vm.$set(_vm.localCue.data.partsData[_vm.getPartIndex(partData)], "label", $$v)
        },
        expression: "localCue.data.partsData[getPartIndex(partData)].label"
      }
    })], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
      staticClass: "flex-row"
    }, [(_vm.isAvailable('time')) ? _c('md-input-container', {
      staticClass: "field-time"
    }, [_c('label', {
      attrs: {
        "for": "time"
      }
    }, [_vm._v("Time")]), _vm._v(" "), _c('md-input', {
      attrs: {
        "readonly": !_vm.editable
      },
      on: {
        "blur": function($event) {
          _vm.modifyCue(("localCue.data.partsData[" + (_vm.getPartIndex(partData)) + "].time"), _vm.localCue.data.partsData[_vm.getPartIndex(partData)].time)
        }
      },
      model: {
        value: (_vm.localCue.data.partsData[_vm.getPartIndex(partData)].time),
        callback: function($$v) {
          _vm.$set(_vm.localCue.data.partsData[_vm.getPartIndex(partData)], "time", $$v)
        },
        expression: "localCue.data.partsData[getPartIndex(partData)].time"
      }
    })], 1) : _vm._e(), _vm._v(" "), (_vm.isAvailable('focus')) ? _c('md-input-container', {
      staticClass: "field-focus"
    }, [_c('label', {
      attrs: {
        "for": "focus"
      }
    }, [_vm._v("Focus")]), _vm._v(" "), _c('md-input', {
      attrs: {
        "readonly": !_vm.editable
      },
      on: {
        "blur": function($event) {
          _vm.modifyCue(("localCue.data.partsData[" + (_vm.getPartIndex(partData)) + "].focus"), _vm.localCue.data.partsData[_vm.getPartIndex(partData)].focus)
        }
      },
      model: {
        value: (_vm.localCue.data.partsData[_vm.getPartIndex(partData)].focus),
        callback: function($$v) {
          _vm.$set(_vm.localCue.data.partsData[_vm.getPartIndex(partData)], "focus", $$v)
        },
        expression: "localCue.data.partsData[getPartIndex(partData)].focus"
      }
    })], 1) : _vm._e(), _vm._v(" "), (_vm.isAvailable('color')) ? _c('md-input-container', {
      staticClass: "field-color"
    }, [_c('label', {
      attrs: {
        "for": "color"
      }
    }, [_vm._v("Color")]), _vm._v(" "), _c('md-input', {
      attrs: {
        "readonly": !_vm.editable
      },
      on: {
        "blur": function($event) {
          _vm.modifyCue(("localCue.data.partsData[" + (_vm.getPartIndex(partData)) + "].color"), _vm.localCue.data.partsData[_vm.getPartIndex(partData)].color)
        }
      },
      model: {
        value: (_vm.localCue.data.partsData[_vm.getPartIndex(partData)].color),
        callback: function($$v) {
          _vm.$set(_vm.localCue.data.partsData[_vm.getPartIndex(partData)], "color", $$v)
        },
        expression: "localCue.data.partsData[getPartIndex(partData)].color"
      }
    })], 1) : _vm._e(), _vm._v(" "), (_vm.isAvailable('beam')) ? _c('md-input-container', {
      staticClass: "field-beam"
    }, [_c('label', {
      attrs: {
        "for": "beam"
      }
    }, [_vm._v("Beam")]), _vm._v(" "), _c('md-input', {
      attrs: {
        "readonly": !_vm.editable
      },
      on: {
        "blur": function($event) {
          _vm.modifyCue(("localCue.data.partsData[" + (_vm.getPartIndex(partData)) + "].beam"), _vm.localCue.data.partsData[_vm.getPartIndex(partData)].beam)
        }
      },
      model: {
        value: (_vm.localCue.data.partsData[_vm.getPartIndex(partData)].beam),
        callback: function($$v) {
          _vm.$set(_vm.localCue.data.partsData[_vm.getPartIndex(partData)], "beam", $$v)
        },
        expression: "localCue.data.partsData[getPartIndex(partData)].beam"
      }
    })], 1) : _vm._e(), _vm._v(" "), (_vm.isAvailable('mark')) ? _c('md-input-container', {
      staticClass: "field-mark"
    }, [_c('label', {
      attrs: {
        "for": "mark"
      }
    }, [_vm._v("M")]), _vm._v(" "), _c('md-select', {
      attrs: {
        "disabled": !_vm.editable
      },
      on: {
        "change": _vm.updateCue
      },
      model: {
        value: (_vm.localCue.data.partsData[_vm.getPartIndex(partData)].mark),
        callback: function($$v) {
          _vm.$set(_vm.localCue.data.partsData[_vm.getPartIndex(partData)], "mark", $$v)
        },
        expression: "localCue.data.partsData[getPartIndex(partData)].mark"
      }
    }, _vm._l((['', 'M', 'D', 'R', '+', 'x']), function(mark, index) {
      return _c('md-option', {
        key: index,
        attrs: {
          "value": mark
        }
      }, [_vm._v(_vm._s(mark))])
    }), 1)], 1) : _vm._e()], 1)])
  }), 0) : _c('div', {
    staticClass: "flex-row"
  }, [(_vm.isAvailable('time')) ? _c('md-input-container', {
    staticClass: "field-time"
  }, [_c('label', {
    attrs: {
      "for": "time"
    }
  }, [_vm._v("Time")]), _vm._v(" "), _c('md-input', {
    attrs: {
      "readonly": !_vm.editable
    },
    on: {
      "blur": function($event) {
        return _vm.modifyCue('data.time', _vm.localCue.data.time)
      }
    },
    model: {
      value: (_vm.localCue.data.time),
      callback: function($$v) {
        _vm.$set(_vm.localCue.data, "time", $$v)
      },
      expression: "localCue.data.time"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.isAvailable('focus')) ? _c('md-input-container', {
    staticClass: "field-focus"
  }, [_c('label', {
    attrs: {
      "for": "focus"
    }
  }, [_vm._v("Focus")]), _vm._v(" "), _c('md-input', {
    attrs: {
      "readonly": !_vm.editable
    },
    on: {
      "blur": function($event) {
        return _vm.modifyCue('data.focus', _vm.localCue.data.focus)
      }
    },
    model: {
      value: (_vm.localCue.data.focus),
      callback: function($$v) {
        _vm.$set(_vm.localCue.data, "focus", $$v)
      },
      expression: "localCue.data.focus"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.isAvailable('color')) ? _c('md-input-container', {
    staticClass: "field-color"
  }, [_c('label', {
    attrs: {
      "for": "color"
    }
  }, [_vm._v("Color")]), _vm._v(" "), _c('md-input', {
    attrs: {
      "readonly": !_vm.editable
    },
    on: {
      "blur": function($event) {
        return _vm.modifyCue('data.color', _vm.localCue.data.color)
      }
    },
    model: {
      value: (_vm.localCue.data.color),
      callback: function($$v) {
        _vm.$set(_vm.localCue.data, "color", $$v)
      },
      expression: "localCue.data.color"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.isAvailable('beam')) ? _c('md-input-container', {
    staticClass: "field-beam"
  }, [_c('label', {
    attrs: {
      "for": "beam"
    }
  }, [_vm._v("Beam")]), _vm._v(" "), _c('md-input', {
    attrs: {
      "readonly": !_vm.editable
    },
    on: {
      "blur": function($event) {
        return _vm.modifyCue('data.beam', _vm.localCue.data.beam)
      }
    },
    model: {
      value: (_vm.localCue.data.beam),
      callback: function($$v) {
        _vm.$set(_vm.localCue.data, "beam", $$v)
      },
      expression: "localCue.data.beam"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.isAvailable('mark')) ? _c('md-input-container', {
    staticClass: "field-mark"
  }, [_c('label', {
    attrs: {
      "for": "mark"
    }
  }, [_vm._v("M")]), _vm._v(" "), _c('md-select', {
    attrs: {
      "disabled": !_vm.editable
    },
    on: {
      "change": _vm.updateCue
    },
    model: {
      value: (_vm.localCue.data.mark),
      callback: function($$v) {
        _vm.$set(_vm.localCue.data, "mark", $$v)
      },
      expression: "localCue.data.mark"
    }
  }, _vm._l((['', 'M', 'D', 'R', '+', 'x']), function(mark, index) {
    return _c('md-option', {
      key: index,
      attrs: {
        "value": mark
      }
    }, [_vm._v(_vm._s(mark))])
  }), 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "flex-row"
  }, [(_vm.isAvailable('duration')) ? _c('md-input-container', {
    staticClass: "field-duration"
  }, [_c('label', {
    attrs: {
      "for": "duration"
    }
  }, [_vm._v("Duration")]), _vm._v(" "), _c('md-input', {
    attrs: {
      "readonly": !_vm.editable
    },
    on: {
      "blur": function($event) {
        return _vm.modifyCue('data.duration', _vm.localCue.data.duration)
      }
    },
    model: {
      value: (_vm.localCue.data.duration),
      callback: function($$v) {
        _vm.$set(_vm.localCue.data, "duration", $$v)
      },
      expression: "localCue.data.duration"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.isAvailable('followHang')) ? _c('md-input-container', {
    staticClass: "field-follow-hang-type"
  }, [_c('label', {
    attrs: {
      "for": "follow-hang-type"
    }
  }, [_vm._v("F/H")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.localCue.data.followHangType),
      expression: "localCue.data.followHangType"
    }],
    staticClass: "custom-select",
    attrs: {
      "disabled": !_vm.editable
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.localCue.data, "followHangType", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.updateCue]
    }
  }, _vm._l((['', 'F', 'H']), function(fh, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": fh
      }
    }, [_vm._v(_vm._s(fh))])
  }), 0)]) : _vm._e(), _vm._v(" "), (_vm.isAvailable('followHang')) ? _c('md-input-container', {
    staticClass: "field-follow-hang"
  }, [_c('label', {
    attrs: {
      "for": "follow-hang"
    }
  }, [_vm._v("Fw/Hg")]), _vm._v(" "), _c('md-input', {
    attrs: {
      "readonly": !_vm.editable
    },
    on: {
      "blur": function($event) {
        return _vm.modifyCue('data.followHang', _vm.localCue.data.followHang)
      }
    },
    model: {
      value: (_vm.localCue.data.followHang),
      callback: function($$v) {
        _vm.$set(_vm.localCue.data, "followHang", $$v)
      },
      expression: "localCue.data.followHang"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.isAvailable('block')) ? _c('md-input-container', {
    staticClass: "field-block"
  }, [_c('label', {
    attrs: {
      "for": "block"
    }
  }, [_vm._v("Block")]), _vm._v(" "), _c('md-select', {
    attrs: {
      "disabled": !_vm.editable
    },
    on: {
      "change": _vm.updateCue
    },
    model: {
      value: (_vm.localCue.data.block),
      callback: function($$v) {
        _vm.$set(_vm.localCue.data, "block", $$v)
      },
      expression: "localCue.data.block"
    }
  }, _vm._l((['', 'B', 'I', 'b']), function(block, index) {
    return _c('md-option', {
      key: index,
      attrs: {
        "value": block
      }
    }, [_vm._v(_vm._s(block))])
  }), 1)], 1) : _vm._e(), _vm._v(" "), (_vm.isAvailable('assert')) ? _c('md-input-container', {
    staticClass: "field-assert"
  }, [_c('label', {
    attrs: {
      "for": "assert"
    }
  }, [_vm._v("Assert")]), _vm._v(" "), _c('md-select', {
    attrs: {
      "disabled": !_vm.editable
    },
    on: {
      "change": _vm.updateCue
    },
    model: {
      value: (_vm.localCue.data.assert),
      callback: function($$v) {
        _vm.$set(_vm.localCue.data, "assert", $$v)
      },
      expression: "localCue.data.assert"
    }
  }, _vm._l((['', 'A', 'a']), function(assert, index) {
    return _c('md-option', {
      key: index,
      attrs: {
        "value": assert
      }
    }, [_vm._v(_vm._s(assert))])
  }), 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "flex-row"
  }, [(_vm.isAvailable('link')) ? _c('md-input-container', {
    staticClass: "field-link"
  }, [_c('label', {
    attrs: {
      "for": "link"
    }
  }, [_vm._v("Link")]), _vm._v(" "), _c('md-input', {
    attrs: {
      "readonly": !_vm.editable
    },
    on: {
      "blur": function($event) {
        return _vm.modifyCue('data.link', _vm.localCue.data.link)
      }
    },
    model: {
      value: (_vm.localCue.data.link),
      callback: function($$v) {
        _vm.$set(_vm.localCue.data, "link", $$v)
      },
      expression: "localCue.data.link"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.isAvailable('loop')) ? _c('md-input-container', {
    staticClass: "field-loop"
  }, [_c('label', {
    attrs: {
      "for": "loop"
    }
  }, [_vm._v("Loop")]), _vm._v(" "), _c('md-input', {
    attrs: {
      "readonly": !_vm.editable
    },
    on: {
      "blur": function($event) {
        return _vm.modifyCue('data.loop', _vm.localCue.data.loop)
      }
    },
    model: {
      value: (_vm.localCue.data.loop),
      callback: function($$v) {
        _vm.$set(_vm.localCue.data, "loop", $$v)
      },
      expression: "localCue.data.loop"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.isAvailable('curve')) ? _c('md-input-container', {
    staticClass: "field-curve"
  }, [_c('label', {
    attrs: {
      "for": "curve"
    }
  }, [_vm._v("Curve")]), _vm._v(" "), _c('md-input', {
    attrs: {
      "readonly": !_vm.editable
    },
    on: {
      "blur": function($event) {
        return _vm.modifyCue('data.curve', _vm.localCue.data.curve)
      }
    },
    model: {
      value: (_vm.localCue.data.curve),
      callback: function($$v) {
        _vm.$set(_vm.localCue.data, "curve", $$v)
      },
      expression: "localCue.data.curve"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.isAvailable('externalLinks')) ? _c('md-input-container', {
    staticClass: "field-external-links"
  }, [_c('label', {
    attrs: {
      "for": "external-links"
    }
  }, [_vm._v("Ext Links")]), _vm._v(" "), _c('md-input', {
    attrs: {
      "readonly": !_vm.editable
    },
    on: {
      "blur": function($event) {
        return _vm.modifyCue('data.externalLinks', _vm.localCue.data.externalLinks)
      }
    },
    model: {
      value: (_vm.localCue.data.externalLinks),
      callback: function($$v) {
        _vm.$set(_vm.localCue.data, "externalLinks", $$v)
      },
      expression: "localCue.data.externalLinks"
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "flex-row"
  }, [(_vm.isAvailable('notes')) ? _c('md-input-container', {
    staticClass: "field-notes"
  }, [_c('label', {
    attrs: {
      "for": "notes"
    }
  }, [_vm._v("Notes")]), _vm._v(" "), _c('md-input', {
    attrs: {
      "readonly": !_vm.editable
    },
    on: {
      "blur": function($event) {
        return _vm.modifyCue('data.notes', _vm.localCue.data.notes)
      }
    },
    model: {
      value: (_vm.localCue.data.notes),
      callback: function($$v) {
        _vm.$set(_vm.localCue.data, "notes", $$v)
      },
      expression: "localCue.data.notes"
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "flex-row"
  }, [(_vm.isAvailable('target')) ? _c('md-input-container', {
    staticClass: "field-target"
  }, [_c('label', {
    attrs: {
      "for": "target"
    }
  }, [_vm._v("Target")]), _vm._v(" "), _c('md-input', {
    attrs: {
      "readonly": !_vm.editable
    },
    on: {
      "blur": function($event) {
        return _vm.modifyCue('data.target', _vm.localCue.data.target)
      }
    },
    model: {
      value: (_vm.localCue.data.target),
      callback: function($$v) {
        _vm.$set(_vm.localCue.data, "target", $$v)
      },
      expression: "localCue.data.target"
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "flex-row"
  }, [(_vm.isAvailable('preWait')) ? _c('md-input-container', {
    staticClass: "field-preWait"
  }, [_c('label', {
    attrs: {
      "for": "pre-wait"
    }
  }, [_vm._v("Pre Wait")]), _vm._v(" "), _c('md-input', {
    attrs: {
      "readonly": !_vm.editable
    },
    on: {
      "blur": function($event) {
        return _vm.modifyCue('data.preWait', _vm.localCue.data.preWait)
      }
    },
    model: {
      value: (_vm.localCue.data.preWait),
      callback: function($$v) {
        _vm.$set(_vm.localCue.data, "preWait", $$v)
      },
      expression: "localCue.data.preWait"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.isAvailable('action')) ? _c('md-input-container', {
    staticClass: "field-action"
  }, [_c('label', {
    attrs: {
      "for": "action"
    }
  }, [_vm._v("Action")]), _vm._v(" "), _c('md-input', {
    attrs: {
      "readonly": !_vm.editable
    },
    on: {
      "blur": function($event) {
        return _vm.modifyCue('data.action', _vm.localCue.data.action)
      }
    },
    model: {
      value: (_vm.localCue.data.action),
      callback: function($$v) {
        _vm.$set(_vm.localCue.data, "action", $$v)
      },
      expression: "localCue.data.action"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.isAvailable('postWait')) ? _c('md-input-container', {
    staticClass: "field-postWait"
  }, [_c('label', {
    attrs: {
      "for": "post-wait"
    }
  }, [_vm._v("Post Wait")]), _vm._v(" "), _c('md-input', {
    attrs: {
      "readonly": !_vm.editable
    },
    on: {
      "blur": function($event) {
        return _vm.modifyCue('data.postWait', _vm.localCue.data.postWait)
      }
    },
    model: {
      value: (_vm.localCue.data.postWait),
      callback: function($$v) {
        _vm.$set(_vm.localCue.data, "postWait", $$v)
      },
      expression: "localCue.data.postWait"
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "flex-row"
  }, [(_vm.isAvailable('placement')) ? _c('md-input-container', {
    staticClass: "field-placement"
  }, [_c('label', {
    attrs: {
      "for": "placement"
    }
  }, [_vm._v("Placement")]), _vm._v(" "), _c('md-input', {
    attrs: {
      "readonly": !_vm.editable
    },
    on: {
      "blur": function($event) {
        return _vm.modifyCue('data.placement', _vm.localCue.data.placement)
      }
    },
    model: {
      value: (_vm.localCue.data.placement),
      callback: function($$v) {
        _vm.$set(_vm.localCue.data, "placement", $$v)
      },
      expression: "localCue.data.placement"
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "flex-row"
  }, [(_vm.isAvailable('purpose')) ? _c('md-input-container', {
    staticClass: "field-purpose"
  }, [_c('label', {
    attrs: {
      "for": "purpose"
    }
  }, [_vm._v("Purpose")]), _vm._v(" "), _c('md-input', {
    attrs: {
      "readonly": !_vm.editable
    },
    on: {
      "blur": function($event) {
        return _vm.modifyCue('data.purpose', _vm.localCue.data.purpose)
      }
    },
    model: {
      value: (_vm.localCue.data.purpose),
      callback: function($$v) {
        _vm.$set(_vm.localCue.data, "purpose", $$v)
      },
      expression: "localCue.data.purpose"
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "flex-row"
  }, [(_vm.isAvailable('followMode')) ? _c('md-input-container', {
    staticClass: "field-followMode"
  }, [_c('label', {
    attrs: {
      "for": "follow-mode"
    }
  }, [_vm._v("Follow Mode")]), _vm._v(" "), _c('md-input', {
    attrs: {
      "readonly": !_vm.editable
    },
    on: {
      "blur": function($event) {
        return _vm.modifyCue('data.followMode', _vm.localCue.data.followMode)
      }
    },
    model: {
      value: (_vm.localCue.data.followMode),
      callback: function($$v) {
        _vm.$set(_vm.localCue.data, "followMode", $$v)
      },
      expression: "localCue.data.followMode"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.isAvailable('routing')) ? _c('md-input-container', {
    staticClass: "field-routing"
  }, [_c('label', {
    attrs: {
      "for": "routing"
    }
  }, [_vm._v("Routing")]), _vm._v(" "), _c('md-input', {
    attrs: {
      "readonly": !_vm.editable
    },
    on: {
      "blur": function($event) {
        return _vm.modifyCue('data.routing', _vm.localCue.data.routing)
      }
    },
    model: {
      value: (_vm.localCue.data.routing),
      callback: function($$v) {
        _vm.$set(_vm.localCue.data, "routing", $$v)
      },
      expression: "localCue.data.routing"
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "flex-row"
  }, [(_vm.isAvailable('trigger')) ? _c('md-input-container', {
    staticClass: "field-trigger"
  }, [_c('label', {
    attrs: {
      "for": "trigger"
    }
  }, [_vm._v("Trigger")]), _vm._v(" "), _c('md-input', {
    attrs: {
      "readonly": !_vm.editable
    },
    on: {
      "blur": function($event) {
        return _vm.modifyCue('data.trigger', _vm.localCue.data.trigger)
      }
    },
    model: {
      value: (_vm.localCue.data.trigger),
      callback: function($$v) {
        _vm.$set(_vm.localCue.data, "trigger", $$v)
      },
      expression: "localCue.data.trigger"
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "flex-row"
  }, [_c('md-input-container', {
    staticClass: "field-label"
  }, [_c('label', {
    attrs: {
      "for": "work-note"
    }
  }, [_vm._v("Work Note")]), _vm._v(" "), _c('md-input', {
    attrs: {
      "readonly": !_vm.editable
    },
    on: {
      "blur": function($event) {
        return _vm.modifyCue('data.workNote', _vm.localCue.data.workNote)
      }
    },
    model: {
      value: (_vm.localCue.data.workNote),
      callback: function($$v) {
        _vm.$set(_vm.localCue.data, "workNote", $$v)
      },
      expression: "localCue.data.workNote"
    }
  }), _vm._v(" "), _c('md-button', {
    staticClass: "md-icon-button md-dense btn-mark-workNote",
    class: {
      'workNote-marked': !!_vm.localCue.data.workNote
    },
    on: {
      "click": _vm.toggleWorkNote
    }
  }, [_c('md-icon', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.localCue.data.workNote),
      expression: "!localCue.data.workNote"
    }]
  }, [_vm._v("check_box_outline_blank")]), _vm._v(" "), _c('md-icon', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.localCue.data.workNote),
      expression: "localCue.data.workNote"
    }]
  }, [_vm._v("check_box")])], 1)], 1)], 1), _vm._v(" "), _c('div', {}, [_c('md-button', {
    staticClass: "md-dense btn-close-button",
    on: {
      "click": _vm.toggle
    }
  }, [_vm._v("Close")])], 1)]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-518904dc","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/print/cues/cue-body.vue
// module id = 1243
// module chunks = 21